import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ChassiViewModel } from "src/domain/client";
import { BrandService } from "src/services/brand.service";
import { RedirectBrandService } from "src/services/redirect-brand.service";

@Component({
  selector: "vw-redirect-brand",
  templateUrl: "./redirect-brand.component.html",
})
export class RedirectBrandComponent implements OnInit, OnDestroy {
  redirectSubscription?: Subscription;
  selectedCar?: ChassiViewModel;
  logoImageSource?: string;
  fromBrand?: string;
  redirectUrl?: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private redirectBrandService: RedirectBrandService,
    private brandService: BrandService,
  ) {}

  ngOnInit(): void {
    this.redirectSubscription =
      this.redirectBrandService.openRedirectBrand$.subscribe(
        (data: ChassiViewModel) => {
          this.selectedCar = data;
          this.setRedirectUrl();
          this.disableScroll();
        },
      );
  }

  ngOnDestroy(): void {
    this.redirectSubscription?.unsubscribe();
  }

  redirectBrand(event: MouseEvent): void {
    event.preventDefault();
    //If the vehicle has a specialBrandCode, we redirect to the correct site.
    window.location.href = this.selectedCar?.specialBrandCode
      ? `/${this.selectedCar.specialBrand?.urlShort}`
      : `/${this.selectedCar?.brand?.urlShort}`;
  }

  backToFromBrandURL(): void {
    this.router
      .navigate([this.brandService?.brand?.urlShort], {
        relativeTo: this.route,
      })
      .then(() => {
        this.enableScroll();
        this.selectedCar = undefined;
      });
  }

  disableScroll(): void {
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("stop-scrolling");
  }

  enableScroll(): void {
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove("stop-scrolling");
  }

  ////
  private setRedirectUrl(): void {
    this.redirectUrl = this.selectedCar?.specialBrandCode
      ? this.selectedCar?.specialBrand?.url
      : this.selectedCar?.brand?.url;
  }
}
